<template>
  <v-dialog v-model="show" max-width="600" persistent>
    <v-card>
      <v-card-title style="display: flex; justify-content: center">
        <span style="font-family: 'montserrat-bold'; font-size: 25px;">Restablecer contraseña</span>
      </v-card-title>
      <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
        <span style="font-family: 'montserrat-semibold'; font-size: 15px;">Ingresa tu contraseña actual y la nueva contraseña para continuar.</span>
      </v-card-subtitle>
      <v-card-text class="pb-1">
        <v-container>
          <v-form
            ref="passwordForm"
            v-model="passwordValid"
            autocomplete="off"
            lazy-validation
            v-on:submit.prevent
          >
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="currentPassword"
                  :rules="currentPasswordRules"
                  label="Contraseña actual *"
                  required
                  outlined
                  style="border-radius: 10px"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showCurrentPassword = !showCurrentPassword"
                  autocomplete="current-password"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="Nueva contraseña *"
                  required
                  outlined
                  style="border-radius: 10px"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  autocomplete="new-password"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="passwordConfirm"
                  :rules="confirmPasswordRules"
                  label="Confirmar nueva contraseña *"
                  required
                  outlined
                  style="border-radius: 10px"
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPasswordConfirm = !showPasswordConfirm"
                  autocomplete="new-password"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
        <v-btn
          color="black"
          elevation="8"
          class="mr-2 px-10"
          style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
          outlined
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="black"
          elevation="8"
          class="white--text px-10"
          style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
          :loading="isLoadingResetPassword"
          :disabled="!passwordValid"
          @click="resetPassword"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogResetPassword",
  props: {
    value: Boolean
  },
  data() {
    return {
      currentPassword: "",
      password: "",
      passwordConfirm: "",
      passwordValid: false,
      isLoadingResetPassword: false,
      showCurrentPassword: false,
      showPassword: false,
      showPasswordConfirm: false,
      currentPasswordRules: [
        (v) => !!v || "La contraseña actual es obligatoria"
      ],
      passwordRules: [
        (v) => !!v || "La contraseña es obligatoria",
        (v) =>
          v.length >= 6 || "La contraseña debe tener al menos 6 caracteres"
      ],
      confirmPasswordRules: [
        (v) => !!v || "La confirmación es obligatoria",
        (v) => v === this.password || "Las contraseñas no coinciden"
      ]
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.resetForm();
      }
    },
    password(val) {
      // Para que la validación de confirmación se actualice
      this.$refs.passwordForm && this.$refs.passwordForm.validate();
    }
  },
  methods: {
    close() {
      this.show = false;
      this.resetForm();
    },
    resetForm() {
      this.currentPassword = "";
      this.password = "";
      this.passwordConfirm = "";
      this.passwordValid = false;
      this.isLoadingResetPassword = false;
      this.showCurrentPassword = false;
      this.showPassword = false;
      this.showPasswordConfirm = false;
    },
    resetPassword() {
      if (!this.$refs.passwordForm.validate()) return;
      this.isLoadingResetPassword = true;

      const payload = {
        sCurrentPassword: this.currentPassword,
        sPassword: this.password,
        sConfirmPassword: this.passwordConfirm
      };

      DB.put(
        `${URI}/api/v1/${this.$store.state.language}/recovery-passwords/admin`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.$parent.mixError(response.data.message, response.status);
            this.isLoadingResetPassword = false;
          } else {
            this.$parent.mixSuccess(
              response.data.message,
              response.status
            );
            this.close();

            // Cerrar sesión inmediatamente después de cambiar contraseña
            localStorage.clear();
            this.$store.commit("setIsLogged", false);
            this.$store.commit("setToken", "");
            this.$store.commit("setFullName", "");
            this.$store.commit("setEnterpriseId", "");
            this.$store.commit("setUserId", "");
            this.$router.push('/login');
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response?.data?.message || "Error al cambiar contraseña",
            error.response?.status
          );
          this.isLoadingResetPassword = false;
        });
    }
  }
};
</script>